<template>
    <div>
        <textarea :id="id"></textarea>
    </div>
</template>

<script>
export default {
    name: 'TinyMCE',
    props: {
        value: {
            type: String,
            default: ''
        },
        maxh: {
            type: Number,
            default: 500
        },
        minh: {
            type: Number,
            default: 270
        }
    },
    data() {
        return {
            id: 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + ''),
            fullscreen: false
        }
    },
    mounted() {
        this.initTinymce()
    },
    activated() {
        this.initTinymce()
    },
    deactivated() {
        this.destroyTinymce()
    },
    destroyed() {
        this.destroyTinymce()
    },
    methods: {
        initTinymce() {
            const self = this
            window.tinymce.init({
                selector: '#' + self.id,
                language: 'zh_CN',
                branding: false,
                min_height: self.minh,
                max_height: self.maxh,
                menubar: false,
                toolbar: [
                    'styleselect fontselect  formatselect  fontsizeselect  forecolor backcolor  bold italic underline strikethrough  image  media  table  alignleft aligncenter alignright alignjustify  outdent indent ',
                    'numlist bullist | preview removeformat  hr  paste code  link  undo redo  fullscreen'
                ],
                plugins: [
                    'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount'
                ],
                forced_root_block: 'p',
                force_p_newlines: true,
                importcss_append: true,
                content_style: `
            *                         { padding:0; margin:0; }
            html, body                { height:100%; }
            img                       { max-width:100%; display:block;height:auto; }
            a                         { text-decoration: none; }
            iframe                    { width: 100%; }
            p                         { line-height:1.6; margin: 0px; }
            table                     { word-wrap:break-word; word-break:break-all; max-width:100%; border:none; border-color:#999; }
            .mce-object-iframe        { width:100%; box-sizing:border-box; margin:0; padding:0; }
            ul,ol                     { list-style-position:inside; }
          `,
                insert_button_items: 'inserttable | image link',
                paste_retain_style_properties: 'all',
                paste_word_valid_elements: '*[*]', // word需要它
                paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
                paste_convert_word_fake_lists: false, // 插入word文档需要该属性
                paste_webkit_styles: 'all',
                paste_merge_formats: true,
                nonbreaking_force_tab: false,
                paste_auto_cleanup_on_paste: false,
                fontsize_formats: '10px 11px 12px 14px 16px 18px 20px 24px',
                font_formats: `
            微软雅黑=微软雅黑;
            宋体=宋体;
            黑体=黑体;
            仿宋=仿宋;
            楷体=楷体;
            隶书=隶书;
            幼圆=幼圆;
            Andale Mono=andale mono,times;
            Arial=arial, helvetica,
            sans-serif;
            Arial Black=arial black, avant garde;
            Book Antiqua=book antiqua,palatino;
            Comic Sans MS=comic sans ms,sans-serif;
            Courier New=courier new,courier;
            Georgia=georgia,palatino;
            Helvetica=helvetica;
            Impact=impact,chicago;
            Symbol=symbol;
            Tahoma=tahoma,arial,helvetica,sans-serif;
            Terminal=terminal,monaco;
            Times New Roman=times new roman,times;
            Trebuchet MS=trebuchet ms,geneva;
            Verdana=verdana,geneva;
            Webdings=webdings;
            Wingdings=wingdings,zapf dingbats
          `,
                tabfocus_elements: ':prev,:next',
                object_resizing: true,
                imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
                images_upload_handler: function(blobInfo, success, failure) {
                    if (blobInfo.blob().size > 2048 * 1024) {
                        failure('文件体积过大')
                    } else if ('image/jpeg,image/png,image/gif'.indexOf(blobInfo.blob().type) < 0) {
                        failure('图片格式错误')
                    } else {
                        self.$http
                            .post('/comm/base/image/upload', {
                                file: blobInfo.blob(),
                                type: 'EditorImage'
                            })
                            .then(result => {
                                if (result.code === 0) {
                                    success(result.data.url)
                                } else {
                                    failure('上传图片失败' + result.msg)
                                }
                            })
                            .catch(() => {
                                failure('上传图片失败')
                            })
                    }
                },
                setup(editor) {
                    editor.on('init', () => {
                        editor.setContent(self.value)
                    })
                    editor.on('FullscreenStateChanged', e => {
                        self.fullscreen = e.state
                    })
                    editor.on('NodeChange Change KeyUp ', () => {
                        self.$emit('input', editor.getContent())
                    })
                }
            })
        },
        destroyTinymce() {
            const tinymce = window.tinymce.get(this.id)
            if (this.fullscreen) {
                tinymce.execCommand('mceFullScreen')
            }
            if (tinymce) {
                tinymce.destroy()
            }
        },
        setContent(value) {
            window.tinymce.get(this.id).setContent(value)
        },
        getContent() {
            window.tinymce.get(this.id).getContent()
        }
    }
}
</script>
